import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import Table from 'react-bootstrap/Table';
import { app } from '../firebase';
import { getFirestore, collection, query, where, getDocs } from 'firebase/firestore';
import './Dash.css'
import NavBar from '../Components/NavBar'
import LeftBar from '../Components/LeftBar'
import ClientComp from './ClientComp'

function ClientOrdersPage() {
    const { clientId } = useParams();
    const db = getFirestore(app);
    const [orders, setOrders] = useState([]);

    useEffect(() => {
        const fetchOrders = async () => {
            const q = query(collection(db, 'Orders'), where('clientId', '==', clientId));
            const snapshot = await getDocs(q);
            const ordersData = [];
            snapshot.forEach(doc => ordersData.push({ id: doc.id, ...doc.data() }));
            setOrders(ordersData);
        };
        fetchOrders();
    }, [db, clientId]);

    return (
        <div className='contentMain'>
            <LeftBar />
            <div className='theRightOne'>
                <div className='DashTop'>
                    <h1>Orders</h1>
                    <NavBar />
                </div>
                <div className="p-4">
                    <h5>Client Orders / Trips</h5>
                    <Table striped bordered hover responsive>
                        <thead>
                            <tr>
                                <th>From</th>
                                <th>To</th>
                                <th>Status</th>
                                <th>Feedback</th>
                            </tr>
                        </thead>
                        <tbody>
                            {orders.map(order => (
                                <tr key={order.id}>
                                    <td>{order.fromLocation || 'N/A'}</td>
                                    <td>{order.toLocation || 'N/A'}</td>
                                    <td>{order.status}</td>
                                    <td>{order.feedback || '-'}</td>
                                </tr>
                            ))}
                        </tbody>
                    </Table>
                </div>
            </div>
        </div>
    );
}

export default ClientOrdersPage;